/* ============================================================
   Skin Protocol — Desktop v2 · interactions
   (Subscription removed — one-time purchase only.)
   ============================================================ */
(function () {
  'use strict';

  if (window.__spProtocolJsLoaded) return;
  window.__spProtocolJsLoaded = true;

  /* ---------- config from the server (Liquid) ---------- */
  var CONFIG = {};
  try {
    var cfgEl = document.getElementById('SpProductConfig');
    if (cfgEl) CONFIG = JSON.parse(cfgEl.textContent);
  } catch (e) { CONFIG = {}; }

  var MONEY_FORMAT = CONFIG.moneyFormat || 'AED {{amount}}';
  var VARIANT_ID = CONFIG.variantId || null;

  function formatMoney(cents) {
    if (cents == null || isNaN(cents)) return '';
    // "AED" + smart decimals: 39500 -> "AED 395", 1742.8 -> "AED 17.43"
    var hasFraction = (Math.round(cents) % 100) !== 0;
    var num = (cents / 100).toLocaleString('en-AE', {
      minimumFractionDigits: hasFraction ? 2 : 0,
      maximumFractionDigits: 2
    });
    return 'AED ' + num;
  }

  function getPlanData() {
    var compareAt = CONFIG.compareAtPrice || 61000;
    var oncePrice = CONFIG.oncePrice || 48800;
    var oneSave = compareAt - oncePrice;

    // One-time off percentage
    var oneOffPct = compareAt > 0 ? Math.round((compareAt - oncePrice) / compareAt * 100) : 20;

    return {
      onetime: {
        now: formatMoney(oncePrice),
        was: compareAt > oncePrice ? formatMoney(compareAt) : '',
        save: oneSave > 0 ? 'Save ' + formatMoney(oneSave) : '',
        off: oneSave > 0 ? oneOffPct + '% OFF' : '',
        day: '≈ ' + formatMoney(oncePrice / 30) + '/day', /* one protocol = 30 days */
        inst: '4 × ' + formatMoney(oncePrice / 4),
        meta: 'One-time purchase · free UAE delivery'
      }
    };
  }

  var PLAN = getPlanData();
  var plan = 'onetime';

  function $(s, r) { return (r || document).querySelector(s); }
  function $all(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function setText(sel, v) { $all(sel).forEach(function (el) { el.textContent = v; }); }

  function applyPlan(p) {
    if (!document.getElementById('SpProductConfig')) return; /* only apply on pages that use this config */
    plan = 'onetime';
    /* window.__protoPlanOverride is set by the 30/60-day choice (snippets/protocol-plan-picker) */
    var d = window.__protoPlanOverride || PLAN.onetime;
    setText('[data-now]', d.now);
    setText('[data-was]', d.was);
    setText('[data-save]', d.save);
    setText('[data-off]', d.off);
    setText('[data-day]', d.day);
    setText('[data-inst]', d.inst);

    /* sticky bar reflects the chosen plan */
    setText('[data-sb-now]', d.now);
    setText('[data-sb-was]', d.was);
    setText('[data-sb-off]', d.off);
  }

  /* ---- add to cart ---- */
  function addToCart(label, btn) {
    if (!VARIANT_ID) {
      // Prototype mode fallback if no real product variant is configured
      cartAdd([], label, btn);
      return;
    }

    var item = {
      id: VARIANT_ID,
      quantity: window.__protoQty || 1 /* 2 when "60 days · 2 protocols" is chosen */
    };

    cartAdd([item], label, btn);
  }

  function cartAdd(items, label, btn) {
    if (btn) btn.setAttribute('aria-busy', 'true');

    var valid = items.filter(function (it) { return it.id; });
    if (!valid.length) {
      showToast(label || 'Added to cart');
      if (btn) setTimeout(function () { btn.removeAttribute('aria-busy'); }, 600);
      return;
    }

    if (typeof window.baAddToCart === 'function') {
      window.baAddToCart(valid, {
        toastMessage: label || 'Added to cart',
        onDone: function () { if (btn) btn.removeAttribute('aria-busy'); },
        onError: function () { if (btn) btn.removeAttribute('aria-busy'); }
      });
      return;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: valid })
    }).then(function (r) { return r.ok ? r.json() : Promise.reject(); })
      .then(function () {
        showToast(label || 'Added to cart');
        if (btn) btn.removeAttribute('aria-busy');
        openCart();
      })
      .catch(function () {
        if (btn) btn.removeAttribute('aria-busy');
      });
  }

  function showToast(msg) {
    var t = $('[data-toast]');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(window.__spToast);
    window.__spToast = setTimeout(function () { t.classList.remove('show'); }, 2000);
  }

  function openCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        $all('[data-cart-ct]').forEach(function (c) { c.textContent = cart.item_count; });
      })
      .catch(function () {});

    if (typeof window.__bacOpenDrawer === 'function') { window.__bacOpenDrawer(); return; }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }
    ['cart:open', 'drawer:open', 'cart-drawer:open'].forEach(function (ev) {
      document.dispatchEvent(new CustomEvent(ev, { bubbles: true }));
    });
  }

  /* ---- timeline stepper ---- */
  var TL = [];
  try {
    var tlEl = document.getElementById('SpTimelineConfig');
    if (tlEl) TL = JSON.parse(tlEl.textContent);
  } catch (e) {}

  if (!TL || !TL.length) {
    TL = [
      { wk: 'Weeks 1–3', t: 'Foundation sets', p: 'Peptides are signalling, astaxanthin is protecting, glutathione begins clearing oxidative load. Skin may feel more hydrated by day 10–14.', i: 'Habit confirmed within 2 weeks', pct: 8 },
      { wk: 'Weeks 4–6', t: 'Radiance emerges', p: 'Skin tone starts to even. The dull, flat quality from oxidative damage recedes. People ask if you’ve changed your moisturiser.', i: 'Week 5 — subscribers commit', pct: 38 },
      { wk: 'Weeks 7–10', t: 'Others notice', p: 'All three mechanisms compound simultaneously. Firmness, radiance and tone peak. Collagen density visibly improves at the structural level.', i: 'Week 8 — most reviews posted', pct: 68 },
      { wk: 'Week 12', t: 'New baseline', p: 'Fine lines measurably reduced, elasticity improved. Each month builds on the gains already made. Most customers continue well past 90 days.', i: '90% renew at the 90-day mark', pct: 100 }
    ];
  }

  function setTl(n) {
    var steps = $all('[data-tl-step]');
    steps.forEach(function (s, i) { s.classList.toggle('active', i === n); s.classList.toggle('done', i <= n); });
    var fill = $('[data-tl-fill]'); if (fill) { var w = steps.length > 1 ? (n / (steps.length - 1)) * 100 : 0; fill.style.width = 'calc(' + w + '% )'; }
    var d = TL[n]; if (!d) return;
    setText('[data-tl-wk]', d.wk); setText('[data-tl-ttl]', d.t); setText('[data-tl-p]', d.p); setText('[data-tl-i]', d.i);
  }

  /* ---- ingredient tabs ---- */
  function setIng(n) {
    $all('[data-ing]').forEach(function (t) { t.classList.toggle('on', t.dataset.ing === String(n)); });
    $all('[data-ing-panel]').forEach(function (p) { p.classList.toggle('on', p.dataset.ingPanel === String(n)); });
  }

  /* ---- science mechanism infographic tabs ---- */
  function setMechViz(n) {
    $all('[data-mv-tab]').forEach(function (t) { t.classList.toggle('on', t.dataset.mvTab === String(n)); });
    $all('[data-mv-panel]').forEach(function (p) { p.classList.toggle('on', p.dataset.mvPanel === String(n)); });
  }

  /* ---- FAQ ---- */
  function toggleFaq(btn) {
    var item = btn.closest('[data-faq-item]');
    var open = item.classList.contains('open');
    $all('[data-faq-item]').forEach(function (f) { f.classList.remove('open'); });
    if (!open) item.classList.add('open');
  }

  /* ---- review lightbox ---- */
  function openReview(card) {
    var src = card.dataset.video || '';
    var vid = $('[data-rv-video]');
    var playbig = $('[data-rv-playbig]');
    if (vid) {
      if (src) {
        vid.src = src;
        vid.style.display = 'block';
        if (playbig) playbig.style.display = 'none';
        vid.load();
        vid.play().catch(function(){});
      } else {
        vid.style.display = 'none';
        if (playbig) playbig.style.display = '';
      }
    }
    setText('[data-rv-handle]', card.dataset.handle);
    setText('[data-rv-cap]', card.dataset.caption);
    setText('[data-rv-views]', card.dataset.views);
    $('[data-rv-modal]').classList.add('show');
    document.body.style.overflow = 'hidden';
  }
  function closeReview() {
    var vid = $('[data-rv-video]');
    var playbig = $('[data-rv-playbig]');
    if (vid) { vid.pause(); vid.src = ''; vid.style.display = 'none'; }
    if (playbig) playbig.style.display = '';
    $('[data-rv-modal]').classList.remove('show');
    document.body.style.overflow = '';
  }

  /* ---- collapsible description (clamp to 2 lines) ---- */
  function initDescClamp() {
    var d = $('[data-desc]'), b = $('[data-desc-toggle]');
    if (!d || !b) return;
    d.classList.add('clamp');
    var overflowing = d.scrollHeight > d.clientHeight + 2;
    b.classList.toggle('show', overflowing);
    if (!overflowing) { b.classList.remove('open'); }
  }
  function toggleDesc(btn) {
    var d = $('[data-desc]'); if (!d) return;
    var clamped = d.classList.toggle('clamp');
    btn.classList.toggle('open', !clamped);
    btn.textContent = clamped ? 'Read more' : 'Read less';
  }

  /* ---- build-a-bundle ---- */
  var BB_PRODUCTS = [];
  try {
    var bundleEl = document.getElementById('SpBundleConfig');
    if (bundleEl) BB_PRODUCTS = JSON.parse(bundleEl.textContent);
  } catch (e) {}

  if (!BB_PRODUCTS || !BB_PRODUCTS.length) {
    BB_PRODUCTS = [
      { id: 'collagen', name: 'Liquid Collagen', price: 197, vial: 'linear-gradient(158deg,#b14a60,#5a1730)' },
      { id: 'asta',     name: 'Astaxanthin',     price: 165, vial: 'linear-gradient(158deg,#2f8163,#0e3d2b)' },
      { id: 'gluta',    name: 'Glutathione',     price: 175, vial: 'linear-gradient(158deg,#e9b8c6,#b8607a)' },
      { id: 'hydra',    name: 'Hyaluronic+',     price: 145, vial: 'linear-gradient(158deg,#79c3c6,#1f6e6a)' },
      { id: 'biotin',   name: 'Biotin Glow',     price: 139, vial: 'linear-gradient(158deg,#e6c878,#9c6f24)' },
      { id: 'vitc',     name: 'Vitamin C+',      price: 149, vial: 'linear-gradient(158deg,#f0a85c,#c2611f)' }
    ];
  }

  var BB_MAX = 4;
  var BB_TIERS = [{ n: 1, off: 0 }, { n: 2, off: .1 }, { n: 3, off: .2 }, { n: 4, off: .3 }];
  var bbPicks = [];

  function fmtAED(n) {
    var hasFraction = Math.abs(n - Math.round(n)) > 0.005;
    return 'AED ' + Number(n).toLocaleString('en-AE', {
      minimumFractionDigits: hasFraction ? 2 : 0,
      maximumFractionDigits: 2
    });
  }
  function bbProduct(id) { for (var i = 0; i < BB_PRODUCTS.length; i++) { if (BB_PRODUCTS[i].id === id) return BB_PRODUCTS[i]; } }
  function bbTierFor(count) { var t = BB_TIERS[0]; for (var i = 0; i < BB_TIERS.length; i++) { if (count >= BB_TIERS[i].n) t = BB_TIERS[i]; } return t; }
  var CHECK = '<svg viewBox="0 0 24 24"><path d="M5 13l4 4L19 7" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function bbInit() {
    var picker = $('[data-bb-picker]');
    if (picker) picker.innerHTML = BB_PRODUCTS.map(function (p) {
      return '<button class="bp" data-bb-pick="' + p.id + '">' +
        '<span class="bp-ct" data-bb-pickct="' + p.id + '" style="display:none">0</span>' +
        '<span class="bp-vial" style="background:' + p.vial + '"></span>' +
        '<span class="bp-n">' + p.name + '</span>' +
        '<span class="bp-p">' + fmtAED(p.price) + '</span></button>';
    }).join('');
    var ms = $('[data-bb-ms]');
    if (ms) ms.innerHTML = BB_TIERS.map(function (t) {
      var left = ((t.n - 1) / (BB_MAX - 1)) * 100;
      var lbl = t.off ? Math.round(t.off * 100) + '%' : 'Pick';
      return '<div class="milestone" data-ms="' + t.n + '" style="left:' + left + '%">' +
        '<div class="ms-dot">' + CHECK + '</div><div class="ms-label">' + lbl + '</div></div>';
    }).join('');

    // Preselected items
    bbPicks = [];
    BB_PRODUCTS.forEach(function (p) {
      if (p.preselected) {
        bbPicks.push(p.id);
      }
    });

    bbUpdate(false);
  }

  function bbUpdate(animate) {
    var count = bbPicks.length;
    var tier = bbTierFor(count);
    var off = count >= 1 ? tier.off : 0;
    var subtotal = bbPicks.reduce(function (s, id) { return s + bbProduct(id).price; }, 0);
    var saved = Math.round(subtotal * off);
    var total = subtotal - saved;
    var pct = Math.min(100, (count / BB_MAX) * 100);

    var fill = $('[data-bb-fill]'); if (fill) fill.style.width = pct + '%';

    $all('[data-ms]').forEach(function (m) {
      var n = +m.dataset.ms, hit = count >= n, was = m.classList.contains('hit');
      m.classList.toggle('hit', hit);
      if (hit && !was && animate) { m.classList.add('justhit'); setTimeout(function () { m.classList.remove('justhit'); }, 480); }
    });

    var hint = $('[data-bb-hint]');
    if (hint) {
      var next = null; for (var i = 0; i < BB_TIERS.length; i++) { if (BB_TIERS[i].n > count) { next = BB_TIERS[i]; break; } }
      if (count === 0) hint.innerHTML = 'Add a formula to start saving ✨';
      else if (next) hint.innerHTML = 'Add <b>' + (next.n - count) + ' more</b> to unlock <b>' + Math.round(next.off * 100) + '% off</b>';
      else hint.innerHTML = 'Max savings unlocked — <b>30% off</b> 🎉';
    }

    var slots = $('[data-bb-slots]');
    if (slots) {
      var html = '';
      for (var s = 0; s < BB_MAX; s++) {
        var id = bbPicks[s];
        if (id) { var p = bbProduct(id);
          html += '<div class="slot slot-filled' + (animate && s === count - 1 ? ' pop' : '') + '">' +
            '<button class="slot-x" data-bb-remove="' + s + '" aria-label="Remove"><svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18" stroke-linecap="round"/></svg></button>' +
            '<span class="slot-vial" style="background:' + p.vial + '"></span><span class="slot-name">' + p.name + '</span></div>';
        } else {
          html += '<div class="slot slot-empty' + (s === count ? ' next' : '') + '"><span class="plus"><svg viewBox="0 0 24 24"><path d="M12 5v14M5 12h14" stroke-linecap="round"/></svg></span></div>';
        }
      }
      slots.innerHTML = html;
    }

    $all('[data-bb-pickct]').forEach(function (el) {
      var pid = el.dataset.bbPickct, n = bbPicks.filter(function (x) { return x === pid; }).length;
      el.style.display = n > 0 ? 'grid' : 'none'; el.textContent = n;
    });
    $all('[data-bb-pick]').forEach(function (b) { b.disabled = count >= BB_MAX; });

    var oc = $('[data-bb-offchip]'); if (oc) { oc.textContent = Math.round(off * 100) + '% off'; oc.classList.toggle('zero', off === 0); }

    var list = $('[data-bb-list]');
    if (list) {
      if (count === 0) list.innerHTML = '<div class="bsum-empty">Your protocol is empty.<br>Tap a formula to start stacking your savings.</div>';
      else list.innerHTML = bbPicks.map(function (id, idx) { var p = bbProduct(id);
        return '<div class="bsum-item"><span class="bi-vial" style="background:' + p.vial + '"></span>' +
          '<span class="bi-n">' + p.name + '</span><span class="bi-p">' + fmtAED(p.price) + '</span>' +
          '<button class="bi-x" data-bb-remove="' + idx + '" aria-label="Remove">✕</button></div>';
      }).join('');
    }

    var rows = $('[data-bb-rows]');
    if (rows) {
      if (count === 0) rows.innerHTML = '';
      else {
        var deliv = total >= 300 ? 'FREE' : fmtAED(25);
        rows.innerHTML = '<div class="bsum-row"><span>' + count + ' formula' + (count > 1 ? 's' : '') + '</span><span class="tnum">' + fmtAED(subtotal) + '</span></div>' +
          (off > 0 ? '<div class="bsum-row save"><span>Bundle discount (' + Math.round(off * 100) + '%)</span><span class="tnum">−' + fmtAED(saved) + '</span></div>' : '') +
          '<div class="bsum-row"><span>Delivery</span><span>' + deliv + '</span></div>' +
          '<div class="bsum-row total"><span class="tl">Total</span><span class="tv tnum">' + fmtAED(total) + '</span></div>';
      }
    }

    var cta = $('[data-bb-add]'), ctaTxt = $('[data-bb-cta]');
    if (cta) cta.disabled = count === 0;
    if (ctaTxt) ctaTxt.textContent = count === 0 ? 'Add a formula' : 'Add protocol — ' + fmtAED(total);
  }

  function bbPick(id) { if (bbPicks.length >= BB_MAX) return; bbPicks.push(id); bbUpdate(true); }
  function bbRemove(i) { bbPicks.splice(i, 1); bbUpdate(false); }

  function bbAddToCart() {
    if (!bbPicks.length) return;
    var count = bbPicks.length, tier = bbTierFor(count);

    var itemsToAdd = bbPicks.map(function (id) {
      var p = bbProduct(id);
      if (p && p.variantId) {
        return { id: p.variantId, quantity: 1 };
      }
      return null;
    }).filter(Boolean);

    var btn = $('[data-bb-add]');
    var toastMsg = 'Protocol added — ' + Math.round(tier.off * 100) + '% off ✓';

    cartAdd(itemsToAdd, toastMsg, btn);
    bbPicks = [];
    bbUpdate(false);
  }

  /* ---- bottom sticky bar (appears once hero buy box scrolls out) ---- */
  function initSticky() {
    var buy = $('[data-buy]'); var bar = $('[data-stickybar]');
    if (!buy || !bar) return;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        bar.classList.toggle('show', !en[0].isIntersecting);
      }, { rootMargin: '0px 0px -60% 0px' }).observe(buy);
    }
  }

  /* ---- announcement ticker ---- */
  function initTicker() {
    var msgs = $all('[data-announce-msg]'); if (msgs.length < 2) return;
    var i = 0; msgs[0].classList.add('on');
    setInterval(function () {
      msgs[i].classList.remove('on');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('on');
    }, 3200);
  }

  /* ---- reveal on scroll ---- */
  function initReveal() {
    var els = $all('.reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---- smooth scroll to buy ---- */
  function scrollToBuy() {
    var el = $('[data-buy]') || $('#hero');
    if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 90, behavior: 'smooth' });
  }

  /* ---- delegated clicks ---- */
  document.addEventListener('click', function (e) {
    var t;
    if ((t = e.target.closest('[data-desc-toggle]'))) toggleDesc(t);
    else if ((t = e.target.closest('[data-mech-toggle]'))) {
      var card = t.closest('.mech-card'); if (!card) return;
      var open = card.classList.toggle('open');
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
      t.childNodes[0].nodeValue = open ? 'Read less' : 'Read more';
    }
    else if ((t = e.target.closest('[data-bb-pick]'))) bbPick(t.dataset.bbPick);
    else if ((t = e.target.closest('[data-bb-remove]'))) { e.stopPropagation(); bbRemove(+t.dataset.bbRemove); }
    else if ((t = e.target.closest('[data-bb-add]'))) bbAddToCart();
    /* The sticky bar's [data-add] has its own add-to-cart (sections/sp-sticky-atc) — skip it here,
       otherwise one tap could add the product twice. */
    else if ((t = e.target.closest('[data-add]')) && !t.closest('[data-stickybar]')) { e.preventDefault(); addToCart(t.dataset.add, t); }
    else if ((t = e.target.closest('[data-scroll-buy]'))) { e.preventDefault(); scrollToBuy(); }
    else if ((t = e.target.closest('[data-tl-step]'))) setTl(+t.dataset.tlStep);
    else if ((t = e.target.closest('[data-thumb]'))) { setPic($all('[data-thumb]').indexOf(t)); }
    else if ((t = e.target.closest('[data-gal-dot]'))) { setPic($all('[data-gal-dot]').indexOf(t)); }
    else if ((t = e.target.closest('[data-gal-seg]'))) { setPic($all('[data-gal-seg]').indexOf(t)); }
    else if (e.target.closest('[data-gal-prev]')) { setPic(galIndex - 1); }
    else if (e.target.closest('[data-gal-next]')) { setPic(galIndex + 1); }
    else if ((t = e.target.closest('[data-ing]'))) setIng(t.dataset.ing);
    else if ((t = e.target.closest('[data-mv-tab]'))) setMechViz(t.dataset.mvTab);
    else if ((t = e.target.closest('[data-faq]'))) toggleFaq(t);
    else if ((t = e.target.closest('[data-review]'))) openReview(t);
    else if (e.target.closest('[data-rv-close]') || e.target === $('[data-rv-modal]')) closeReview();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeReview(); });

  /* ---- hero gallery: thumbnails (desktop) + swipe (mobile) ---- */
  var galIndex = 0;
  function setPic(i) {
    var thumbs = $all('[data-thumb]');
    if (!thumbs.length) return;
    i = (i + thumbs.length) % thumbs.length;
    galIndex = i;
    var th = thumbs[i];
    thumbs.forEach(function (x, k) { x.classList.toggle('on', k === i); });
    $all('[data-gal-dot]').forEach(function (d, k) { d.classList.toggle('on', k === i); });
    $all('[data-gal-seg]').forEach(function (s, k) { s.classList.toggle('on', k === i); });
    var ph = $('[data-gal-stage]');
    if (ph) {
      ph.classList.remove('pic-green', 'pic-terra', 'pic-pink');
      if (th.classList.contains('g2')) ph.classList.add('pic-green');
      else if (th.classList.contains('g3')) ph.classList.add('pic-terra');
      else if (th.classList.contains('g4')) ph.classList.add('pic-pink');
      var lab = th.querySelector('.ph');
      ph.setAttribute('data-label', lab ? lab.textContent : '');
    }
    // real media slides
    $all('[data-gal-slide-idx]').forEach(function (sl, k) {
      sl.style.display = k === i ? 'block' : 'none';
      sl.classList.toggle('on', k === i);
    });
    var main = $('[data-gal-main]');
    if (main) main.classList.toggle('not-hero', i !== 0);
  }
  function initGallery() {
    var main = $('[data-gal-main]');
    if (!main) return;
    var startX = null, startY = null, dragging = false;
    main.addEventListener('pointerdown', function (e) {
      startX = e.clientX; startY = e.clientY; dragging = true;
    });
    window.addEventListener('pointerup', function (e) {
      if (!dragging) return; dragging = false;
      if (startX == null) return;
      var dx = e.clientX - startX, dy = e.clientY - startY;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) setPic(galIndex + (dx < 0 ? 1 : -1));
      startX = startY = null;
    });
    // cap the vertical thumb rail to the picture height (desktop row layout only)
    var rail = $('.gal-thumbs');
    function syncRail() {
      if (!rail) return;
      if (window.innerWidth > 1000) rail.style.maxHeight = main.offsetHeight + 'px';
      else rail.style.maxHeight = '';
    }
    syncRail();
    window.addEventListener('resize', function () { clearTimeout(window.__railRz); window.__railRz = setTimeout(syncRail, 150); });
    window.addEventListener('load', syncRail);

    // horizontal trackpad scroll over the picture changes the shot (vertical scroll still scrolls the page)
    var wheelLock = false;
    main.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) < 24 || Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
      e.preventDefault();
      if (wheelLock) return;
      wheelLock = true;
      setPic(galIndex + (e.deltaX > 0 ? 1 : -1));
      setTimeout(function () { wheelLock = false; }, 360);
    }, { passive: false });
  }

  function boot() {
    PLAN = getPlanData();
    applyPlan('onetime'); setTl(0); setIng(1);
    initSticky(); initTicker(); initReveal(); bbInit();
    initDescClamp(); initGallery();

    // Sync cart count on load
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $all('[data-cart-ct]').forEach(function (c) { c.textContent = cart.item_count; });
      })
      .catch(function () {});

    window.addEventListener('resize', function () { clearTimeout(window.__descRz); window.__descRz = setTimeout(initDescClamp, 200); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
